var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { Dialog2 } from "../../../../misc/Dialog2";
import { useAsyncAction } from "nate-react-api-helpers";
import { useEffect } from "react";
import { api } from "../../../../api/API";
import { useSnackbar } from "../../../../misc/Snackbar";
import { useSyncedRef } from "../../../../misc/SyncedRef";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SaveAsPresetDialog(props) {
    const snack = useSnackbar();
    const doneRef = useSyncedRef(props.onDone);
    const snackRef = useSyncedRef(snack);
    const action = useAsyncAction((input) => __awaiter(this, void 0, void 0, function* () { yield api.quoteMiscPricing.upsertPreset(input); snackRef.current.success("Preset saved"); doneRef.current(); }), []);
    useEffect(() => {
        action.callback({ category: props.category, description: props.description }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ _jsxs(Dialog2, { open: true, onClose: props.onDone, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: "Save as Preset" }), /*#__PURE__*/ _jsxs(DialogContent, { children: [/*#__PURE__*/ _jsxs(DialogContentText, { children: ["Saving \"", props.category, "\" as a preset\u2026"] }), action.LoadingElement] }), /*#__PURE__*/ _jsx(DialogActions, { children: /*#__PURE__*/ _jsx(Button, { onClick: props.onDone, disabled: action.loading, children: action.error ? "Close" : "Cancel" }) })] });
}
